import { Outlet } from 'react-router-dom';

const GuestLayout = () => (
    <>
        <Outlet />
    </>
);

export default GuestLayout;
